import { Flex, OverflowText } from "@theorgchartdev/storybook";
import { FieldInputValuePickerComposite } from "@/appComponents/Blocks/Composites/FieldInputValuePickerComposite/FieldInputValuePickerComposite";
import React, { useState } from "react";
import {
  IsEditableField,
  SanitizeFieldValue,
  IsFieldNotConfigured
} from "@/appComponents/Blocks/Cards/RecordInfoCard/utils";
import ActionListItem from "@/appComponents/Blocks/Composites/ActionListItem/ActionListItem";
import { handleCopyToClipboard } from "@/Utils/Misc";

export const RecordValueRow = ({
  fVPair,
  delta,
  isEditable,
  isEditing,
  onEdit,
  onUpdate,
  autoFocus,
  onSave,
  otherInputProps,
  setInitialEdit
}) => {
  const { value, fieldName, fieldDef } = fVPair;

  const currentValue = delta[fieldName] ?? value;

  const [copiedField, setCopiedField] = useState(null);

  const [localValue, setLocalValue] = useState(currentValue);

  const doHandleUpdate = (dataItem, value, doSave = false) => {
    onUpdate(dataItem, value, false);
    if (doSave) {
      onSave();
    }
  };

  const clearCopy = () => {
    setCopiedField(null);
  };

  const handleCopyValue = (e, fVPair) => {
    setCopiedField(fieldName);
    setTimeout(clearCopy, 2000);
    handleCopyToClipboard(fVPair.value);
    e.preventDefault();
  };

  const staticTextStyle = {
    minHeight: "15px"
  };

  const notConfigured = IsFieldNotConfigured(currentValue, fieldDef);

  let actions = [];

  if (!isEditing) {
    if (isEditable && IsEditableField(fieldDef)) {
      actions.push({
        iconName: "pen",
        onClick: e => onEdit(e, fVPair),
        iconProps: {
          dataTestId: `record-details-field-edit-${fieldName}`
        }
      });
    }
    actions.push({
      iconName: copiedField === fieldName ? "clipboard-check" : "copy",
      onClick: e => handleCopyValue(e, fVPair)
    });
  }

  //const unsavedChanges = !isNullish(delta[field]);
  const handleQuickEdit = e => onEdit(e, fVPair);

  return (
    <Flex direction="column" width="100%" key={fieldName}>
      {isEditing && IsEditableField(fieldDef) ? (
        <div style={{ paddingRight: "12px" }}>
          <FieldInputValuePickerComposite
            dataTestIdPrefix={"record-detail-field-"}
            showPickListWarning={true}
            inputProps={{
              inputOnly: true,
              autoFocus: autoFocus,
              onBlur: e => {
                doHandleUpdate(fVPair, localValue, false);
              },
              onKeyUp: e => {
                if (e.key === "Enter") {
                  doHandleUpdate(fVPair, localValue, true);
                }
              },
              ...otherInputProps
            }}
            field={fieldName}
            value={localValue}
            onChange={(data, isPickerValue) => {
              setLocalValue(data.value);
              if (isPickerValue === true) {
                doHandleUpdate(fVPair, data.value, false);
              }
            }}
          />
        </div>
      ) : (
        <ActionListItem
          actions={actions}
          contentBefore={
            <div onDoubleClick={handleQuickEdit} style={{ width: "100%" }}>
              <OverflowText
                size="xsmall"
                style={staticTextStyle}
                colorModifier={notConfigured ? "faintgrey" : isEditing ? "lightgrey" : undefined}
                modifier={notConfigured ? "italic" : undefined}
              >
                {SanitizeFieldValue(currentValue, fieldDef)}
              </OverflowText>
            </div>
          }
        />
      )}
    </Flex>
  );
};
